import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { getCallerTemplateDetailPath } from 'routing/paths/caller';
import { useCallerTemplateDictionary } from 'hooks/caller';

// components
import Link from '@material-ui/core/Link';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

interface Props {
  templateId?: number;
  templateName?: string;
  innerProps?: TypographyProps;
}

const defaultProps: TypographyProps = {
  variant: 'caption',
  color: 'textSecondary',
};

const CallerTemplateLink = ({ templateId, templateName, innerProps }: Props): JSX.Element => {
  const { templates } = useCallerTemplateDictionary();
  const template = templates.find((el) => el.template_id === templateId);
  const TypoProps = { ...defaultProps, ...innerProps };

  if (!template) {
    return <Typography { ...TypoProps }>-</Typography>;
  }

  const label = templateName ?? template.name;
  const path = getCallerTemplateDetailPath(String(template.template_suite_id), String(template.template_id));
  return <Link component={ RouterLink } color="secondary" to={ path }>{ label }</Link>;
};

export default CallerTemplateLink;
